import type { NuxtApp } from '#app';

export function useTypedNuxtApp() {
  return useNuxtApp() as NuxtApp;
}
